"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("./store"));

var _Leaderboard = _interopRequireDefault(require("./Leaderboard"));

var _defaultTranslations = _interopRequireDefault(require("./defaultTranslations"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      history = _ref.history,
      betbarParent = _ref.betbarParent,
      setBetbarParent = _ref.setBetbarParent,
      app = _ref.app,
      showPrizeIcons = _ref.showPrizeIcons,
      hidePrizeMoney = _ref.hidePrizeMoney,
      showPrizeIconIfAllQuestionsCorrect = _ref.showPrizeIconIfAllQuestionsCorrect,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages;
  translations = _objectSpread(_objectSpread({}, _defaultTranslations.default), translations);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
    store: _store.default,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Leaderboard.default, {
      translations: translations,
      betbar: betbarParent,
      setBetbar: setBetbarParent,
      app: app,
      isUsingAlternativeImages: isUsingAlternativeImages,
      history: history,
      hidePrizeMoney: hidePrizeMoney,
      showPrizeIcons: showPrizeIcons,
      showPrizeIconIfAllQuestionsCorrect: showPrizeIconIfAllQuestionsCorrect
    })
  });
};

var _default = Wrapper;
exports.default = _default;